// extracted by mini-css-extract-plugin
export default {"mainWrapper":"MainNavigator_mainWrapper__fN5af","mainBody":"MainNavigator_mainBody__VGV05","mainFooter":"MainNavigator_mainFooter__R0Zw-"};